module.exports = __webpack_public_path__ + "img/guide_3_2.5c9c7cad.svg";